module.exports = __webpack_public_path__ + "static/media/RACA.f6b60f02.svg";